import React, { useState, useEffect } from "react";
import CustomDataTable from "../../../components/CustomDataTable";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  setResetStateUser,
  requestUserAction,
  requestUsersListAction,
  setResetStateUsersList,
  requestUserById,
  setResetStateUserById,
  setResetStateEditUser,
  requestEdituser,
} from "../../../Redux/UserState/UserActionCreator";
import Hoc from "../../../components/HOC";
// import AddEmployeeModal from "./AddEmployeeModal";
import Loader from "../../../components/Loader";
import { MdEdit, MdEditDocument } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import {
  requestGetEmpStatus,
  setResetGetEmpStatus,
} from "../../../Redux/EmployeeStatusState/empStatusActionCreator";
import CustomToolTip from "../../../components/ToolTip";
import UserDetailsModal from "./UserDetailsModal";
import ViewEmployeeModal from "./ViewEmployeeModal";
import { FiEye } from "react-icons/fi";
import { statusFilterOptions, userTypeFilterOptions } from "../../../Constants";
import CustomDropdown from "../../../components/CustomDropdown";


const EmployeeTable = () => {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [userTypeFilter, setUserTypeFilter] = useState("ALL");
  const [statusFilter, setStatusFilter] = useState("ALL");
  const usersListState = useSelector((state) => state.UsersListReducer);
  const userDetailsReducer = useSelector((state) => state.UserByIdReducer);
  const addUserReducer = useSelector((state) => state.UserReducer);
  const editUserReducer = useSelector((state) => state.EditUserReducer);
  const getEmpStatusReducer = useSelector((state) => state.GetEmpStatusReducer);

  const navigate = useNavigate();
  const [selectedUser, setSelectedUser] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  
  // const customDropdownStyles = {
  //   control: (base) => ({
  //     ...base,
  //     minHeight: "25px",
  //     height: "25px",
  //     padding: "0 5px",
  //     borderColor: "#cbd5e1",
  //     borderWidth: "1px",
  //     boxShadow: "none",
  //     "&:hover": {
  //       borderColor: "#cbd5e1",
  //     },
  //   }),
  //  };

  // Handle user type filter change
  const handleUserTypeFilterChange = (selectedOption) => {
    if (!selectedOption) {
      setUserTypeFilter("ALL");
    } else {
      setUserTypeFilter(selectedOption.value);
    }
  };

  // Handle status filter change
  const handleStatusFilterChange = (selectedOption) => {
    if (!selectedOption) {
      setStatusFilter("ALL");
    } else {
      setStatusFilter(selectedOption.value);
    }
  };
  
 

  const columns = [
    {
      name: "Name",
      selector: (row) => `${row.firstName} ${row.lastName}`,
      sortable: true,
      cell: (row) => (
        <span className="text-md font-medium">
          {row.firstName} {row.lastName}
        </span>
      ),
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      hide: "sm"
    },
    {
      name: "User Type",
      selector: (row) => row.acctType,
      sortable: true,
      hide: "sm",
      cell: (row) => (
        <span
          className={`px-2 py-1 rounded-full text-xs font-medium ${
            row.acctType === "ADMIN"
              ? "bg-purple-100 text-purple-800"
              : "bg-blue-100 text-blue-800"
          }`}
        >
          {row.acctType}
        </span>
      ),
    }
,    
{
  name: "Status",
  selector: (row) => row.stsCd,
  sortable: true,
  cell: (row) => {
    const statusText = row.stsCd === "A" ? "Active" : "Deactive";
    const statusStyles =
      row.stsCd === "A"
        ? "bg-green-200 text-green-600"
        : "bg-red-200 text-red-600";

    return (
      <span className={`px-3 py-1 rounded-full text-sm font-medium ${statusStyles}`}>
        {statusText}
      </span>
    );
  },
},
    // {
    //   name: "Status",
    //   selector: (row) => row.stsCd,
    //   sortable: true,
    //   cell: (row) => (
    //     <span
    //       className={`px-3 py-1 rounded-full text-sm font-medium 
    //         ${
    //           row.stsCd === "A"
    //             ? "bg-green-200 text-green-600"
    //             : row.stsCd === "D"
    //             ? "bg-red-200 text-red-600"
    //             : "bg-gray-200 text-gray-800"
    //         }`}
    //     >
    //       {row.stsCd}
    //     </span>
    //   ),
    // },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex space-x-2">
          
          <button onClick={() => handleEdit(row)} className="text-primary hover:text-primaryDark">
            <MdEdit size={20} data-tip data-for="registerTip" />
            <CustomToolTip id="registerTip" title="Edit" />
          </button>
          <button onClick={() => handleUpdate(row)} className="text-primary">
            <MdEditDocument size={20} data-tip data-for="rejected" />
            <CustomToolTip id="rejected" title="Status" />
          </button>
          <button 
            onClick={() => handleView(row)} 
            className="text-primary hover:text-primaryDark"
            disabled={userDetailsReducer?.byIdLoading && selectedUserId === row.id}
          >
            {userDetailsReducer?.byIdLoading && selectedUserId === row.id ? (
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-primary"></div>
            ) : (
              <FiEye size={20} data-tip data-for="viewTip" />
            )}
            <CustomToolTip id="viewTip" title="View" />
          </button>
        </div>
      ),
    },
  ];

  const handleDelete = (row) => {};

  const handleEdit = (row) => {
    dispatch(requestUserById(row.id));
    navigate(`/editemployee/${row.id}`, { state: { activeItem: "Employee" } });
  };
  const handleView = (row) => {
    // Prevent multiple API calls if already loading for this user
    if (userDetailsReducer?.byIdLoading && selectedUserId === row.id) {
      return;
    }
    setSelectedUserId(row.id);
    dispatch(requestUserById(row.id));
  };

  const handleClick = () => {
    navigate("/addemployee", { state: { activeItem: "Employee" } });
  };

  const handleUpdate = (row) => {
    navigate(`/addemployeestatus/${row.id}`, {
      state: { activeItem: "Employee" },
    });
  };

  const handleModalClose = () => {
    setIsViewModalOpen(false);
    setSelectedUserId(null);
    dispatch(setResetStateUserById());
  };

  const handlePageChange = (page) => {
    dispatch(
      requestUsersListAction({
        page: page,
        size: usersListState.size,
        search: search,
        acctType: userTypeFilter === "ALL" ? undefined : userTypeFilter,
        stsCd: statusFilter === "ALL" ? undefined : statusFilter,
      })
    );
  };
  
  const handleRowsChange = (size) => {
    dispatch(requestUsersListAction({ 
      page: 0, 
      size: size, 
      search: search,
      acctType: userTypeFilter === "ALL" ? undefined : userTypeFilter,
      stsCd: statusFilter === "ALL" ? undefined : statusFilter,
    }));
    // setSearch("");
  };

  useEffect(() => {
    if (usersListState?.usersError && !usersListState?.usersLoading) {
      // toast.error("No UsersList found / something went wrong")
      dispatch(setResetStateUsersList());
    }
  }, [usersListState]);

  // Handle successful user data fetch and open modal
  useEffect(() => {
    if (userDetailsReducer?.byIdResponse && !userDetailsReducer?.byIdLoading && selectedUserId) {
      setIsViewModalOpen(true);
    }
  }, [userDetailsReducer?.byIdResponse, userDetailsReducer?.byIdLoading, selectedUserId]);

  // Handle API errors
  useEffect(() => {
    if (userDetailsReducer?.byIdError && !userDetailsReducer?.byIdLoading) {
      toast.error("Failed to fetch user details. Please try again.");
      setSelectedUserId(null);
      setIsViewModalOpen(false);
      dispatch(setResetStateUserById());
    }
  }, [userDetailsReducer?.byIdError, userDetailsReducer?.byIdLoading, dispatch]);

  useEffect(() => {
    if (getEmpStatusReducer?.error && !getEmpStatusReducer?.loading) {
      // toast.error("Something went wrong")
      dispatch(setResetGetEmpStatus())
    }
  }, [getEmpStatusReducer]);

  useEffect(() => {
    dispatch(setResetStateUsersList());
    dispatch(
      requestUsersListAction({
        page: usersListState?.page,
        size: usersListState?.size,
        search: search,
        acctType: userTypeFilter === "ALL" ? undefined : userTypeFilter,
        stsCd: statusFilter === "ALL" ? undefined : statusFilter,
      })
    );
    dispatch(setResetStateUserById());
    dispatch(setResetStateUser());
    dispatch(setResetStateEditUser());
    dispatch(setResetGetEmpStatus());
  }, []);

  // useEffect(() => {
  //   const timeoutId = setTimeout(() => {
  //     dispatch(
  //       requestUsersListAction({
  //         page: 0,
  //         size: usersListState?.size,
  //         search: search,
  //         acctType: userTypeFilter === "ALL" ? undefined : userTypeFilter,
  //         stsCd: statusFilter === "ALL" ? undefined : statusFilter,
  //       })
  //     );
  //   }, 500);
  //   return () => clearTimeout(timeoutId);
  // }, [search]);
  
  // Add filter useEffect
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      dispatch(
        requestUsersListAction({
          page: 0,
          size: usersListState?.size,
          search: search,
          acctType: userTypeFilter === "ALL" ? undefined : userTypeFilter,
          stsCd: statusFilter === "ALL" ? undefined : statusFilter,
        })
      );
    }, 300);
    return () => clearTimeout(timeoutId);
  }, [search,userTypeFilter, statusFilter]);

  return (
    <div className="p-6 w-full h-[90vh]">
      <Loader
        isLoading={
          usersListState?.usersLoading ||
          userDetailsReducer?.byIdLoading ||
          editUserReducer?.Loading ||
          addUserReducer?.isLoading||
          getEmpStatusReducer?.loading
        }
      />

      <div className="absolute flex items-center mb-4 z-10 right-6">
        <div className="flex items-center mr-2">
          <div className="flex flex-col md:flex-row gap-4">
            <div className="w-[200px] [&>div]:bg-slate-100 [&>div>div]:bg-slate-100 [&>div>div>div]:bg-slate-100 [&>div>label]:bg-slate-100 [&>div>div]:border-b-2 [&>div>div]:border-gray-200">
              <CustomDropdown
                value={userTypeFilterOptions.find(
                  (option) => option.value === userTypeFilter
                )}
                handleChange={handleUserTypeFilterChange}
                placeholder="User Type"
                options={userTypeFilterOptions}
              />
            </div>
            <div className="w-[200px] [&>div]:bg-slate-100 [&>div>div]:bg-slate-100 [&>div>div>div]:bg-slate-100 [&>div>label]:bg-slate-100 [&>div>div]:border-b-2 [&>div>div]:border-gray-200">
              <CustomDropdown
                value={statusFilterOptions.find(
                  (option) => option.value === statusFilter
                )}
                handleChange={handleStatusFilterChange}
                placeholder="Status"
                options={statusFilterOptions}
              />
            </div>
          </div>
        </div>
        <button
          onClick={handleClick}
          className="flex items-center justify-center bg-primary hover:bg-primaryDark text-white py-1 px-6 mr-4 rounded-full shadow-lg transition-all duration-300"
        >
          <span className="text-2xl font-medium">+</span>
        </button>
      </div>

      <CustomDataTable
        columns={columns}
        search={search}
        setSearch={setSearch}
        data={usersListState?.usersResponse?.content}
        onDelete={handleDelete}
        enableSearch={true} 
        serverPagenation
        paginationTotalRows={usersListState?.usersResponse?.totalElements}
        handleChangePage={handlePageChange}
        handleRowsChange={handleRowsChange}
        fixedHeaderScrollHeight={"65vh"}
      />

      <ViewEmployeeModal
        isOpen={isViewModalOpen}
        onClose={handleModalClose}
        userId={selectedUserId}
      />
    </div>
  );
};
export default Hoc(EmployeeTable);
